var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.545 22.922a.954.954 0 0 1-1.349-.003l-5.619-5.641a.95.95 0 0 1-.273-.767.95.95 0 0 1 .272-.766l5.619-5.663a.954.954 0 0 1 1.354 1.343L8.28 15.727h17.455a.954.954 0 1 1 0 1.907H8.625l3.922 3.94a.954.954 0 0 1-.002 1.348",
    clipRule: "evenodd"
  })));
};
export default SvgArrowLeft;